<div class="login-page">
  <div class="login-card">
    <div class="login-lang">
      <button class="login-lang-btn" [class.login-lang-active]="i18n.lang === 'en'" (click)="i18n.setLang('en')">EN</button>
      <button class="login-lang-btn" [class.login-lang-active]="i18n.lang === 'no'" (click)="i18n.setLang('no')">NO</button>
    </div>

    <div class="login-brand">
      <img class="login-logo" src="assets/img/frigg-icon-150x42.png" alt="Frigg Kantine">
      <div>
        <h1>{{ 'login.title' | translate }}</h1>
        <p>{{ 'login.subtitle' | translate }}</p>
      </div>
    </div>

    <ng-container *ngIf="mode === 'signin'">
      <form (ngSubmit)="signIn()">
        <mat-form-field appearance="outline" class="login-field">
          <mat-label>{{ 'login.email' | translate }}</mat-label>
          <input matInput type="email" name="email" [(ngModel)]="email" autocomplete="username" [disabled]="busy">
        </mat-form-field>

        <mat-form-field appearance="outline" class="login-field">
          <mat-label>{{ 'login.password' | translate }}</mat-label>
          <input matInput type="password" name="password" [(ngModel)]="password"
                 autocomplete="current-password" [disabled]="busy">
        </mat-form-field>

        <div class="login-msg login-error" *ngIf="error">{{ error }}</div>
        <div class="login-msg login-info" *ngIf="info">{{ info }}</div>

        <button mat-flat-button color="primary" class="login-submit" type="submit" [disabled]="busy">
          {{ (busy ? 'login.signingIn' : 'login.signIn') | translate }}
        </button>

        <button mat-button type="button" class="login-link" (click)="switchTo('reset')" [disabled]="busy">
          {{ 'login.forgotPassword' | translate }}
        </button>
      </form>
    </ng-container>

    <ng-container *ngIf="mode === 'reset'">
      <form (ngSubmit)="sendReset()">
        <p class="login-help">
          {{ 'login.resetHelp' | translate }}
        </p>

        <mat-form-field appearance="outline" class="login-field">
          <mat-label>{{ 'login.email' | translate }}</mat-label>
          <input matInput type="email" name="email" [(ngModel)]="email" autocomplete="username" [disabled]="busy">
        </mat-form-field>

        <div class="login-msg login-error" *ngIf="error">{{ error }}</div>

        <button mat-flat-button color="primary" class="login-submit" type="submit" [disabled]="busy">
          {{ (busy ? 'login.sending' : 'login.sendResetLink') | translate }}
        </button>

        <button mat-button type="button" class="login-link" (click)="switchTo('signin')" [disabled]="busy">
          {{ 'login.backToSignIn' | translate }}
        </button>
      </form>
    </ng-container>

    <p class="login-foot">
      {{ 'login.footer' | translate }} <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>.
    </p>
  </div>
</div>
